<template>
    <div id="PlayerEdit">
        <div class="section">
            <h3>Edit Player</h3>
            <h4>{{playerName}}&nbsp;<button @click="deletePlayer" class="btn-floating btn-small grey"><i class="material-icons">delete</i></button></h4>
        </div>
        <div class="section">
          <div class="row">
            <form @submit.prevent="updatePlayer" class="col s12">
              <div class="row">
                <div class="input-field col s12">
                  <input type="text" v-model="playerName" required>
                  <label class="active">Name</label>
                </div>
              </div>
              <div class="row">
                <div class="col s12">
                  <router-link to="/" class="btn grey">Back</router-link>
                  <button type="submit" class="btn green" style="float:right">Save</button>
                </div>
              </div>
            </form>

          </div>
        </div>
    </div>
</template>

<script>

import db from '../components/firebaseInit'

export default {
  name: 'PlayerEdit',
  data() {
    return {
      playerName: null,
    }
  },
  created() {
    // fetch the data when the view is created and the data is
    // already being observed
    this.fetchData();
  },
  watch: {
     // call again the method if the route changes
    '$route': 'fetchData'
  },
  methods: {
    fetchData() {
      db.collection('players').doc(this.$route.params.id).get()
      .then(doc => {
         if (doc.exists) {
           this.playerName = doc.data().playerName;
         } else {
           this.error = "No such document!";
         }
       });
    },
    updatePlayer() {
      db.collection('players').doc(this.$route.params.id).update({
            playerName: this.playerName,
          })
          .then(() => {
            this.$router.push({name: 'PlayerOverview'})
          })
          .catch(error => console.log(err))
    },
    deletePlayer() {
      if(confirm('Are you sure you want to delete this player?')){
        db.collection('players').doc(this.$route.params.id).delete();
          this.$router.push('/')
      }
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/views/PlayerEdit.vue